export enum ELandlordStatusDB {
  ACTIVE = 'ACTIVE',
  TEST = 'TEST',
  PROSPECT = 'PROSPECT',
  NON_LANDLORD = 'NON_LANDLORD',
  INACTIVE = 'INACTIVE',
}

export enum ELandlordStatusUI {
  ACTIVE = 'Active',
  TEST = 'Test',
  PROSPECT = 'Prospect',
  NON_LANDLORD = 'Non-landlord',
  INACTIVE = 'Inactive',
}

export type TLandlordGetUI = {
  id: string;
  name: string;
  username: string;
  status: ELandlordStatusUI;
  propertyManagementId: string;
  resourceId: string;
};

export type TLandlordGetDB = {
  id: string;
  businessName: string;
  landlordUsername: string;
  status: ELandlordStatusDB;
  propertyManagementId: string;
  landlordId: string;
};

export type TChangeLandlordStatusUI = {
  propertyManagementId: string;
  propertyManagementStatus: ELandlordStatusUI;
};

export type TChangeLandlordStatusDB = {
  propertyManagementId: string;
  status: ELandlordStatusDB;
};

export type TPMEmailsExportUI = {
  filters?: { [key: string]: string | string[] | undefined };
  propertyManagementIds?: string[];
};

export type TPMEmailsExportDB = {
  [key: string]: string | string[];
};

export enum ELandlordSortFields {
  name = 'NAME',
}
